function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import get from 'lodash/get';
import { formatDate } from 'helpers/datetime';
import Avatar from 'components/Avatar';
import Button from 'components/Form/Button';
import App from 'modules/App';
import Account from 'modules/Account';
import FormContainerAbstract from 'components/FormContainerAbstract';
import CheckboxRadio from 'components/Form/CheckboxRadio';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as shapes from '../../shapes';
import messages from '../../messages';
import styles from '../ModalCommon.pcss';
import validatorRules from './validatorRules.json';
class MergeOptions extends FormContainerAbstract {
    onSetOption(input) {
        input.id = 'option';
        this.onSetValue(input);
    }
    onSetValues(formName, values) {
        this.props.onSetFormValues(formName, values);
    }
    onSubmit() {
        this.props.onFormProcessing();
        const { validatedValues, errors } = this.onValidate(this.validatorRules);
        this.props.onFormErrors(errors);
        if (!errors) {
            const { option } = validatedValues;
            if (option === 'searchAndBind') {
                this.props.onSetComponent('ChoosePatient');
                return;
            }
            const { activePatient, clinicPatient, sharingRequest, activeClinicMembership } = this.props;
            this.props.onSubmit(activePatient, clinicPatient, sharingRequest, activeClinicMembership);
            this.props.onSetComponent('Merging');
        }
    }
    get isDisabled() {
        const { errors } = this.onValidate(this.requiredRules);
        return !!errors;
    }
    get isOpen() {
        return this.props.openModalId === constants.MERGE_PATIENT_MODAL;
    }
    renderActions() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "modal__actions row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "quaternary",
                        labelMessage: messages.buttons.cancel,
                        className: "btn--block",
                        onClick: this.props.onClose
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "primary",
                        labelMessage: messages.buttons.submit,
                        className: "btn--block btn--filled",
                        isDisabled: this.isDisabled,
                        onClick: ()=>this.onSubmit()
                    })
                })
            ]
        });
    }
    renderPerson(person) {
        const { avatar, firstName, lastName, dateOfBirth } = person || {};
        return /*#__PURE__*/ _jsxs("div", {
            className: cn('row align-items-center', styles.person),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto pr-0",
                    children: /*#__PURE__*/ _jsx(Avatar, {
                        avatarImg: avatar,
                        name: [
                            firstName,
                            lastName
                        ],
                        className: styles.item__avatar,
                        imgClassName: styles.item__avatar__img,
                        initialsClassName: styles.item__avatar__initials
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "col",
                    children: [
                        /*#__PURE__*/ _jsxs("p", {
                            className: styles.person__name,
                            children: [
                                firstName,
                                " ",
                                lastName
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            className: "text--small",
                            children: [
                                /*#__PURE__*/ _jsxs("span", {
                                    className: "text--muted",
                                    children: [
                                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.dateOfBirth)),
                                        ': '
                                    ]
                                }),
                                dateOfBirth ? formatDate(dateOfBirth) : '-'
                            ]
                        })
                    ]
                })
            ]
        });
    }
    renderActivePatient() {
        const { activePatient } = this.props;
        if (!activePatient) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: "px-3",
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: "text--bold",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.activeProfile))
                }),
                this.renderPerson(activePatient)
            ]
        });
    }
    renderClinicPatient() {
        const { clinicPatient } = this.props;
        if (!clinicPatient) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            className: "px-3",
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: "text--bold",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.existingProfile))
                }),
                this.renderPerson(clinicPatient)
            ]
        });
    }
    renderComparison() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    children: this.renderActivePatient()
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    children: this.renderClinicPatient()
                })
            ]
        });
    }
    renderOptions() {
        const value = get(this.props.formValues, 'values.option');
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: "text--bold my-4",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.whatToDoWithRequest))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "form-group",
                    children: this.props.clinicPatient && /*#__PURE__*/ _jsx(CheckboxRadio, {
                        id: "option-bind",
                        inputValue: "bind",
                        value: value,
                        labelMessage: messages.labels.mergeWithFoundProfile,
                        isRadio: true,
                        onChange: (input)=>this.onSetOption(input)
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "form-group",
                    children: /*#__PURE__*/ _jsx(CheckboxRadio, {
                        id: "option-searchAndBind",
                        inputValue: "searchAndBind",
                        value: value,
                        labelMessage: messages.labels.mergeWithOtherProfile,
                        isRadio: true,
                        onChange: (input)=>this.onSetOption(input)
                    })
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.container,
                    "data-testid": "patient-data-comparison",
                    children: [
                        this.renderComparison(),
                        this.renderOptions()
                    ]
                }),
                this.renderActions()
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            option: null
        };
        this.validatorRules = validatorRules;
        this.onSetOption({
            value: props.clinicPatient ? 'bind' : 'searchAndBind'
        });
    }
}
_define_property(MergeOptions, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    // Explicit props
    activePatient: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        dateOfBirth: PropTypes.string
    }),
    clinicPatient: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        dateOfBirth: PropTypes.string
    }),
    sharingRequest: shapes.sharingRequest,
    // Explicit actions
    onSetComponent: PropTypes.func,
    onClose: PropTypes.func,
    // Implicit props
    activeClinicMembership: Account.shapes.clinicMembership,
    // Implicit actions
    onAccept: PropTypes.func
}));
const mergePatientFormSelector = App.selectors.formSelector(constants.MERGE_PATIENT_FORM);
const mapStateToProps = (state)=>({
        activeClinicMembership: Account.selectors.activeClinicMembership(state),
        formValues: mergePatientFormSelector(state)
    });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.MERGE_PATIENT_FORM;
    return {
        onSubmit: (activePatient, clinicPatient, sharingRequest, clinicMembership)=>dispatch(actions.mergePatient(activePatient, clinicPatient, sharingRequest, clinicMembership)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (form, values)=>dispatch(App.actions.setFormValues(form, values)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors))
    };
};
const ConnectedEnrollingRequest = connect(mapStateToProps, mapDispatchToProps)(MergeOptions);
export default ConnectedEnrollingRequest;
